import { sendHttpRequest } from "../../../components/http.request";

export async function select(requestBody) {
    const formData = new FormData();
    Object.entries(requestBody).forEach(([key, value]) => {
        formData.append(key, value);
    });
    return sendHttpRequest("POST", "/Gestor/gerelistas.php", formData).then((jsonResponse) => {
        return jsonResponse.dados;
    });
}

export async function saveOrUpdate(requestBody) {
    const formData = new FormData();
    Object.entries(requestBody).forEach(([key, value]) => {
        formData.append(key, value);
    });
    return sendHttpRequest("POST", "/Gestor/gereprocesso.php", formData).then((jsonResponse) => {
        if (jsonResponse.sucesso && jsonResponse.sucesso !== "0") {
            return true;
        } else return false;
    });
}

export async function remove(requestBody) {
    const formData = new FormData();
    Object.entries(requestBody).forEach(([key, value]) => {
        formData.append(key, value);
    });
    return sendHttpRequest("POST", "/Gestor/gerelistas.php", formData).then((jsonResponse) => {
        if (jsonResponse.sucesso) return true;
        else return false;
    });
}

export async function getDataById(lista, id) {
    const formData = new FormData();
    formData.append("lista", lista);
    formData.append("accao", "dados");
    formData.append("chave1", id);

    return sendHttpRequest("POST", "/Gestor/gerelistas.php", formData).then((jsonResponse) => {
        return jsonResponse.valores;
    });
}
